module.exports = __webpack_public_path__ + "static/media/21skills_logo_colored.8c74755c.png";